<template>
  <div>
    <div style="margin-top: 20px; font-size: 26px; font-weight: bold">
      上家单号和发件人查询
    </div>
    <div style="margin-top: 20px">
      <el-input
        v-model="number"
        placeholder="同步单号"
        style="width: 300px"
        class="filter-item"
        clearable
      />
      <el-button v-waves class="filter-item" type="primary" @click="selectOrderInfo">
        查询
      </el-button>
      <br /><br />
      <span style="font-weight: bold">上家单号：</span>{{ express_no }},
      <span style="font-weight: bold">发件人手机号：</span>{{ send_tel }} <br /><br />
      <span style="font-weight: bold; color: red">{{ errorCommitResult }}</span>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import waves from "@/directive/waves"; // waves directive

export default {
  name: "selectOrderInfo",
  directives: { waves },
  data() {
    return {
      number: "",
      express_no: "",
      send_tel: "",
      errorCommitResult: "",
    };
  },
  methods: {
    selectOrderInfo() {
      this.express_no = "";
      this.send_tel = "";
      this.errorCommitResult = "";
      const url = this.$root.ycApiUrl + "api/selectOrderInfo?number=" + this.number;
      const res = axios.get(url);
      res
        .then((response) => {
          const resd = response.data;
          if (resd.code == 200) {
            this.express_no = resd.data.out_trade_no;
            this.send_tel = resd.data.sender_mobile;
          } else {
            this.errorCommitResult = resd.msg;
          }

          setTimeout(() => {
            return;
          }, 1.5 * 1000);
        })
        .catch((error) => {
          console.error("初始请求失败:", error);
          // 处理错误，比如设置data为默认值或错误状态
          return;
        });
      // Just to simulate the time of the request
      setTimeout(() => {
        this.listLoading = false;
      }, 1.5 * 1000);
    },
  },
};
</script>
<style></style>



// WEBPACK FOOTER //
// src/views/secondGenerationLogistics/selectOrderInfo.vue